import { NEW_COLORS } from '../themes/colors/newColors';

type SummaryItens = {
  label: string;
  color?: string;
  key: string;
};

const GRAPHIC_SUMMARY_DATA: SummaryItens[] = [
  {
    label: 'Titulares',
    key: 'holders',
    color: NEW_COLORS.PRIMARY[500],
  },
  {
    label: 'Dependentes',
    key: 'dependents',
    color: NEW_COLORS.SECONDARY[500],
  },
  {
    label: 'Agregados',
    key: 'aggregates',
    color: NEW_COLORS.SEMANTICS.INFO[600],
  },
];

export { SummaryItens, GRAPHIC_SUMMARY_DATA };
